window.addEventListener("DOMContentLoaded", function() {
    if(!document.querySelector('.email') && !document.querySelector('.address'))
        return;

    var a = Math.round(Math.random() * 100000);
    var b = Math.round(Math.random() * 100000);
    var oReq = new XMLHttpRequest();
    oReq.addEventListener("load", function() {
        if(this.status == 200) {
            var data = JSON.parse(this.responseText);

            document.querySelectorAll('.email').forEach(function(e) {
                e.href = 'mailto:' + data.email;
                e.innerText = data.email;
            });

            document.querySelectorAll('.address').forEach(function(e) {
                e.innerHTML = data.address;
            });
        }
    });
    oReq.open("post", "/personalData.php");
    oReq.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    oReq.send("a="+a+"&b="+b+"&c="+(a+b));
});